/**
 * Document Service
 * Handles PDF and DOCX generation requests for release notes and QA reports
 */
import axios from 'axios';

/**
 * Generate DOCX for release notes
 * @param {string} releaseVersion - Release version
 * @returns {Promise<Blob>} - DOCX blob
 */
export const generateReleaseNotesDocx = async (releaseVersion) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `/api/fix-versions/docx/release-notes/${releaseVersion}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        },
        responseType: 'blob'
      }
    );
    
    console.log('Release Notes DOCX response received:', response.status);
    console.log('Release Notes DOCX content type:', response.headers['content-type']);
    console.log('Release Notes DOCX size:', response.data.size);
    
    // Create a URL for the blob
    const url = window.URL.createObjectURL(response.data);
    
    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `release_notes_${releaseVersion.replace(/\./g, '_')}.docx`;
    
    // Append to the document
    document.body.appendChild(link);
    
    // Trigger the download
    link.click();
    
    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
    
    return response.data;
  } catch (error) {
    console.error('Error generating release notes DOCX:', error);
    throw error;
  }
};

/**
 * Generate PDF for release notes
 * @param {string} releaseVersion - Release version
 * @returns {Promise<Blob>} - PDF blob
 */
export const generateReleaseNotesPdf = async (releaseVersion) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `/api/fix-versions/pdf/release-notes/${releaseVersion}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/pdf'
        },
        responseType: 'blob'
      }
    );
    
    console.log('Release Notes PDF response received:', response.status);
    console.log('Release Notes PDF content type:', response.headers['content-type']);
    console.log('Release Notes PDF size:', response.data.size);
    
    // Create a URL for the blob
    const url = window.URL.createObjectURL(response.data);
    
    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `release_notes_${releaseVersion.replace(/\./g, '_')}.pdf`;
    
    // Append to the document
    document.body.appendChild(link);
    
    // Trigger the download
    link.click();
    
    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
    
    return response.data;
  } catch (error) {
    console.error('Error generating release notes PDF:', error);
    throw error;
  }
};

/**
 * Generate DOCX for QA report
 * @param {string} releaseVersion - Release version
 * @returns {Promise<Blob>} - DOCX blob
 */
export const generateQaReportDocx = async (releaseVersion) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(
      `/api/test/docx/qa-report/${releaseVersion}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        },
        responseType: 'blob'
      }
    );
    
    console.log('QA Report DOCX response received:', response.status);
    console.log('QA Report DOCX content type:', response.headers['content-type']);
    console.log('QA Report DOCX size:', response.data.size);
    
    // Create a URL for the blob
    const url = window.URL.createObjectURL(response.data);
    
    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `qa_report_${releaseVersion.replace(/\./g, '_')}.docx`;
    
    // Append to the document
    document.body.appendChild(link);
    
    // Trigger the download
    link.click();
    
    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
    
    return response.data;
  } catch (error) {
    console.error('Error generating QA report DOCX:', error);
    throw error;
  }
};
